/* PARSE URL
  Parses the current window location's hostname and extracts the top-level domain,
  domain, and environment (env).
*/
export const parseUrl = (): { tld: string; domain: string; env: string; protocol: string } => {
  const [tld, domain, rawEnv = 'prod'] = window.location.hostname.split('.').reverse();
  const env = rawEnv === 'www' ? 'prod' : rawEnv;
  const protocol = window.location.protocol;
  return { protocol, env, domain, tld };
};

/* GET API URL
  This is used to dynamically determine the API URL based on the current hostname.
  It is used for both the GraphQL API as well as the Sockets connections. This URL
  can be set in session storage on the browser for local development purposes.

  The type parameter determines which API URL to generate (e.g., 'api' for the GraphQL API or 'chat' for the chat service). This is for scaling. In the future more sub-domain APIs can be added and used.
*/
export const getApiUrl = (type: string): string => {
  const { protocol, env, domain, tld } = parseUrl();
  const isLocal = location.hostname === 'localhost';
  const url = [type, env, domain, tld].filter(Boolean).join('.');
  const result = `${protocol}//${url}`;
  const localUrl = window.sessionStorage.getItem(`portal_${type}`);
  return isLocal && localUrl ? localUrl : result;
};

/* GET ENVIRONMENT
  Retrieves the current environment (env) from the parsed URL.
*/
export const getEnv = (): string => {
  const { env } = parseUrl();
  const isLocal = location.hostname === 'localhost';
  return isLocal ? 'local' : env;
};

export * from './arrays';
export * from './dates';
export * from './custom';
export * from './strings';
export * from './promises';
export * from './arrays';
export * from './numbers';
export * from './objects';
export * from './events';
export * from './logs';
export * from './styles';
export * from './Dayts';
export * from './validations';
export * from './storage';

export type * from './custom';
